export Icon from './Icon'

export default from './Icon'



// WEBPACK FOOTER //
// ./src/Icon/index.js